// src/pages/psytest/data/constants.js
export const CAREERS = {
  audit: "Public Accounting - Audit / Assurance (審計與鑑證)",
  tax: "Public Accounting - Tax (稅務諮詢)",
  fin_reporting: "Industry - Financial Accounting / Reporting (企業會計/財務報導)",
  fpa: "Industry - FP&A / Management Accounting (財務規劃與分析)",
  consulting: "Consulting / Advisory (顧問與諮詢)",
  global: "Cross-border / Global Mobility Path (跨國職涯發展)",
  forensic: "Forensic Accounting (鑑識會計)",
};

export const CAREER_KEYS = Object.keys(CAREERS);

// 同分優先判定：鑑識會計 > 跨國發展 > 顧問 > FP&A > 審計 > 稅務 > 企業會計
export const TIE_BREAK_PRIORITY = [
  "forensic",
  "global",
  "consulting",
  "fpa",
  "audit",
  "tax",
  "fin_reporting",
];

// 你提供的是「以分數門檻」決定文字（22/17/11）
export const FIT_LEVELS = [
  { minScore: 22, range: "80% - 100%", label: "天生契合！你具備該職涯所需的核心特質與價值觀。" },
  { minScore: 17, range: "60% - 79%", label: "高度適配！該路徑能讓你的優勢得到良好發揮。" },
  { minScore: 11, range: "40% - 59%", label: "潛在發展路徑。你具備基本特質，但部分工作習慣可能需適度調整。" },
  { minScore: 0,  range: "< 40%",      label: "建議參考。你可能更適合其他類型或需進一步探索興趣。" },
];
